import {
  AnchorButton,
  Button,
  Card,
  Classes,
  Collapse,
  ControlGroup,
  Dialog,
  Elevation,
  InputGroup,
  NonIdealState,
  Spinner,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { apiCallPost, niceDateTime } from "../fns/util";
import { inject, observer } from "mobx-react";
import cogoToast from "cogo-toast";
import _ from "lodash";
import { withRouter } from "react-router";
import PatientData from "./PatientData";
import ClickToCopy from "../utils/ClickToCopy";
import SxCalendar from "./SxCalendar";
import SxBookingMetadata from "./SxBookingMetadata";
import SxLineItems from "./SxLineItems";
import SxItems from "./SxItems";
import SxSteps from "./SxSteps";
import PanelAuths from "./PanelAuths";
import SxPayments from "./SxPayments";
import KeyEvents from "./KeyEvents";
import KeyPeople from "./KeyPeople";
import Discharge from "./Discharge";
import SysInv from "./SysInv";
import SxConsumption from "./SxConsumption";
import SxVideo from "./SxVideo";
import { Tab, Tabs } from "@blueprintjs/core";
import EntityFiles from "../v2/EntityFiles";
import EntityComments from "../v2/EntityComments";

class SxLanding extends React.Component {
  state = {
    /** GENERAL STUFF */
    isLoading: true,
    isBusy: false,
    isError: false,
    changed: false,
    /** LOADED DATA */
    loadedDocs: [],
    loadedSites: [],
    isInfoOpen: false,
    dischargeEntities: [],

    showDischarge: false,
    openDailog: false,
  };
  componentDidMount() {
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.sxId
    ) {
      this.setState(
        { isLoading: true, currentSxId: this.props.match.params.sxId },
        () => this.getData()
      );
    } else {
      this.setState({ isLoading: false, isError: true });
    }
  }

  /** SX APIs */
  getData = async () => {
    try {
      cogoToast.loading("Fetching data...");
      this.setState({ isLoading: true });
      let res = await apiCallPost(
        `/booking-sx/${this.props.authStore.prefix}/sxBooking/getById`,
        { _id: this.props.match.params.sxId }
      );

      this.setState({ ...res }, () => this.getSites());
      let diagnosis = res.dischargeEntities.filter(
        (currentItem) =>
          currentItem.sectionName === "EXAMINATION" &&
          (currentItem.subsectionName === "OBSERVATIONS" ||
            currentItem.subsectionName === "DIAGNOSIS")
      );

      if (diagnosis.length > 0) {
        this.setState({ showDischarge: true });
      } else {
        this.setState({ showDischarge: false });
      }

      cogoToast.success("Successfully fetched data.");
    } catch (err) {
      cogoToast.error("We ran into an error fetching the data.");
      this.setState({ isError: true, isLoading: false });
    }
  };
  updateData = async () => {
    this.setState({ isBusy: true });
    let payload = _.cloneDeep(this.state);
    delete payload.isLoading;
    delete payload.isBusy;
    delete payload.isError;
    delete payload.changed;
    delete payload.loadedDocs;
    delete payload.loadedSites;

    try {
      cogoToast.loading("Updating data...");
      console.log("asdsd", payload);

      let res = await apiCallPost(
        `/booking-sx/${this.props.authStore.prefix}/sxBooking/update`,
        { _id: this.state._id, doc: payload }
      );
      this.setState({ ...res, changed: false, isBusy: false });
    } catch (err) {
      cogoToast.error("We ran into an error updating the data.");
      this.setState({ isBusy: false });
    }
  };
  /** DATA APIs */
  getDocs = async () => {
    try {
      this.setState({ isLoading: true });
      let res = await apiCallPost(
        `/rai/${this.props.authStore.prefix}/getAllConsultants`,
        {}
      );

      this.setState(
        {
          loadedDocs: _.sortBy(res, "name"),
        },
        () => {
          this.setState({ isLoading: false });
        }
      );
    } catch (err) {
      cogoToast.error(
        `We ran into an error while loading sites. Please try again. If this error persists, please contact support immediately.`
      );
    }
  };
  getSites = async () => {
    try {
      this.setState({ isLoading: true });
      let res = await apiCallPost(
        `/rai/${this.props.authStore.prefix}/getAllSites`,
        {}
      );

      this.setState(
        {
          loadedSites: res,
        },
        () => this.getDocs()
      );
    } catch (err) {
      cogoToast.error(
        `We ran into an error while loading sites. Please try again. If this error persists, please contact support immediately.`
      );
    }
  };
  validations = () => {
    let lifecycle = this.state.lifecycle;
    if (lifecycle) {
      if (!this.state.anaesthesiaType) {
        cogoToast.error("Please select an anaesthesia type.");
        return;
      }
      if (!this.state.site) {
        cogoToast.error("Please select a site.");
        return;
      }
      if (!this.state.onDay) {
        cogoToast.error("Please select a date.");
        return;
      }
      if (!this.state.time) {
        cogoToast.error("Please select a time.");
        return;
      }
      if (!this.state.surgeonId) {
        cogoToast.error("Please select a surgeon.");
        return;
      }
      if (!this.state.eye) {
        cogoToast.error("Please select an eye.");
        return;
      }
      if (!this.state.diet) {
        cogoToast.error("Please select a diet.");
        return;
      }
      if (!this.state.lineItems || this.state.lineItems.length === 0) {
        cogoToast.error("Please add at least one line item.");
        return;
      }
      let ll = this.state.lineItems;
      let hasSx = false;
      for (let i = 0; i < ll.length; i++) {
        if (ll[i].lineItemType === "SX") {
          hasSx = true;
          break;
        }
      }
      let hasAnaesthesia = false;
      for (let i = 0; i < ll.length; i++) {
        if (ll[i].lineItemType === "ANAESTHESIA") {
          hasAnaesthesia = true;
          break;
        }
      }
      if (!hasSx) {
        cogoToast.error("Please add at least one surgery.");
        return;
      }
      if (!hasAnaesthesia) {
        cogoToast.error("Please add anaesthesia.");
        return;
      }
      if (!this.state.chosenPanelId) {
        cogoToast.error("Please select a panel.");
        return;
      }
      if (!this.state.patientName) {
        cogoToast.error("Please enter patient name.");
        return;
      }
      if (!this.state.patientGenericPid) {
        cogoToast.error("Please enter patient ID.");
        return;
      }
      if (!this.state.patientAddress) {
        cogoToast.error("Please enter patient address.");
        return;
      }
      if (!this.state.patientPhone) {
        cogoToast.error("Please enter patient phone number.");
        return;
      }
      if (!this.state.patientDob) {
        cogoToast.error("Please enter patient date of birth.");
        return;
      }
      if (!this.state.patientSex) {
        cogoToast.error("Please enter patient sex.");
        return;
      }
    }
    if (lifecycle === "DRAFT") {
      return "Done";
    }
    if (lifecycle === "BOOKED") {
      // if (!this.checkEvents("Arrival")) {
      //   cogoToast.error("Please log arrival time.");
      //   return;
      // } else {
      return "Done";
      // }
    }
    if (lifecycle === "BILLED") {
      // if (!this.checkEvents("Arrival")) {
      //   cogoToast.error("Please log arrival time.");
      // return;
      // }
      // if (!this.state.anaesthetistId) {
      //   cogoToast.error("Please select an anaesthetist.");
      //   return;
      // }
      // if (!this.checkEvents("Admission")) {
      //   cogoToast.error("Please log admission time.");
      //   return;
      // }
      // if (!this.checkPeople("Admission")) {
      //   cogoToast.error("Please log admission personnel.");
      //   return;
      // }
      // if (!this.checkPeople("Admission")) {
      //   cogoToast.error("Please log admission personnel.");
      //   return;
      // }
      // if (!this.checkEvents("Block Room")) {
      //   cogoToast.error("Please log block room time.");
      //   return;
      // }
      return "Done";
    }
    if (lifecycle === "IN_BLOCK_ROOM") {
      // let events = ["Arrival", "Admission", "Block Room"];
      // let roles = [
      //   "Admission",
      //   "Block Room Prep Assistant",
      //   "Anaesthesia Assistant",
      //   "OT Prep Assistant",
      //   "Consumable/Implant Prep Assistant",
      //   "Sterilization",
      //   "Floor Assistant",
      // ];
      // let notDone = false;
      // events.map((each) => {
      //   if (!this.checkEvents(each)) {
      //     notDone = true;
      //     cogoToast.error(`Please log ${each} time.`);
      //     return null;
      //   }
      //   return null;
      // });
      // roles.map((each) => {
      //   if (!this.checkPeople(each)) {
      //     notDone = true;
      //     cogoToast.error(`Please log ${each} personnel.`);
      //     return null;
      //   }
      //   return null;
      // });
      // if (notDone) {
      //   return;
      // }
      return "Done";
    }
    if (lifecycle === "IN_OT") {
      // let events = [
      //   "Arrival",
      //   "Admission",
      //   "Block Room",
      //   "Anaesthesia Start",
      //   "Surgery Start",
      //   "Surgery End",
      //   "Anaesthesia End",
      // ];
      // let roles = [
      //   "Admission",
      //   "Block Room Prep Assistant",
      //   "Anaesthesia Assistant",
      //   "OT Prep Assistant",
      //   "Consumable/Implant Prep Assistant",
      //   "Sterilization",
      //   "Floor Assistant",
      // ];
      // let notDone = false;
      // events.map((each) => {
      //   if (!this.checkEvents(each)) {
      //     notDone = true;
      //     cogoToast.error(`Please log ${each} time.`);
      //     return null;
      //   }
      //   return null;
      // });
      // roles.map((each) => {
      //   if (!this.checkPeople(each)) {
      //     notDone = true;
      //     cogoToast.error(`Please log ${each} personnel.`);
      //     return null;
      //   }
      //   return null;
      // });
      // if (notDone) {
      //   return;
      // }
      return "Done";
    }
    if (lifecycle === "SX_DONE") {
      // let events = [
      //   "Arrival",
      //   "Admission",
      //   "Block Room",
      //   "Anaesthesia Start",
      //   "Surgery Start",
      //   "Surgery End",
      //   "Anaesthesia End",
      //   "Moved To Ward",
      //   "Discharge",
      // ];
      // let roles = [
      //   "Admission",
      //   "Block Room Prep Assistant",
      //   "Anaesthesia Assistant",
      //   "OT Prep Assistant",
      //   "Consumable/Implant Prep Assistant",
      //   "Sterilization",
      //   "Floor Assistant",
      //   "Follow-Up & Explanation",
      //   "Discharge",
      // ];
      // let notDone = false;
      // events.map((each) => {
      //   if (!this.checkEvents(each)) {
      //     notDone = true;
      //     cogoToast.error(`Please log ${each} time.`);
      //     return null;
      //   }
      //   return null;
      // });
      // roles.map((each) => {
      //   if (!this.checkPeople(each)) {
      //     notDone = true;
      //     cogoToast.error(`Please log ${each} personnel.`);
      //     return null;
      //   }
      //   return null;
      // });
      // if (notDone) {
      //   return;
      // }
      // if (!this.state.dischargeNotes) {
      //   cogoToast.error("Please enter discharge notes.");
      //   return;
      // }
      // if (!this.state.followUpAppt) {
      //   cogoToast.error("Please enter follow up appointment.");
      //   return;
      // }
      // if (!this.state.postSxContact) {
      //   cogoToast.error("Please enter post surgery contact.");
      //   return;
      // }

      return "Done";
    }
  };
  checkPeople = (role) => {
    let people = this.state.keyPeople;
    let idx = _.findIndex(people, (x) => x.role === role);
    if (idx > -1) {
      return true;
    } else {
      return false;
    }
  };
  checkEvents = (event) => {
    let people = this.state.keyEvents;
    let idx = _.findIndex(people, (x) => x.event === event);
    if (idx > -1) {
      return true;
    } else {
      return false;
    }
  };
  renderLifeCycleAction = () => {
    if (this.state.lifecycle === "DRAFT") {
      return (
        <Button
          loading={this.state.isBusy}
          intent="success"
          text="Confirm Booking"
          onClick={() => {
            if (this.validations() !== "Done") return;
            this.setState({ openDailog: true, lifecycleToSet: "BOOKED" });
            // this.setState({ lifecycle: "BOOKED" }, () => this.updateData());
          }}
        />
      );
    }
    if (this.state.lifecycle === "BOOKED") {
      return (
        <Button
          loading={this.state.isBusy}
          intent="success"
          text="Confirm Billing"
          onClick={() => {
            if (this.validations() !== "Done") return;
            this.setState({ openDailog: true, lifecycleToSet: "BILLED" });
            // , () => this.updateData());
          }}
        />
      );
    }
    if (this.state.lifecycle === "BILLED") {
      return (
        <Button
          loading={this.state.isBusy}
          intent="success"
          text="Send Patient to Block Room"
          onClick={() => {
            if (this.validations() !== "Done") return;
            this.setState(
              { lifecycleToSet: "IN_BLOCK_ROOM", openDailog: true }
              // () => this.updateData()
            );
          }}
        />
      );
    }
    if (this.state.lifecycle === "IN_BLOCK_ROOM") {
      return (
        <Button
          loading={this.state.isBusy}
          intent="success"
          text="Send Patient to OT"
          onClick={() => {
            if (this.validations() !== "Done") return;
            this.setState(
              { lifecycleToSet: "IN_OT", openDailog: true }
              // () => this.updateData()
            );
          }}
        />
      );
    }
    if (this.state.lifecycle === "IN_OT") {
      return (
        <Button
          loading={this.state.isBusy}
          intent="success"
          text="Surgery Done"
          onClick={() => {
            if (this.validations() !== "Done") return;
            this.setState(
              { lifecycleToSet: "SX_DONE", openDailog: true }
              //  () => this.updateData()
            );
          }}
        />
      );
    }
    if (this.state.lifecycle === "SX_DONE") {
      return (
        <Button
          loading={this.state.isBusy}
          intent="success"
          text="Discharge Patient"
          onClick={() => {
            if (this.validations() !== "Done") return;
            this.setState(
              { lifecycleToSet: "DISCHARGED", openDailog: true }
              //  () =>
              // this.updateData()
            );
          }}
        />
      );
    }
  };
  renderBasedOnLifecycle = () => {
    let terminals = ["DISCHARGED", "LAMA", "DEATH", "CANCELLED"];
    if (this.state.lifecycle === "DRAFT") {
      return (
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div style={{ width: "100vw" }}>
            <PatientData
              canEdit={true}
              isBusy={this.state.isBusy}
              data={this.state}
              onUpdate={(data) => {
                this.setState({ ...data, changed: true });
              }}
            />
            <div style={{ marginTop: "10px" }}>
              <SxBookingMetadata
                canEdit={true}
                isBusy={this.state.isBusy}
                data={this.state}
                onUpdate={(data) => {
                  this.setState({ ...data, changed: true });
                }}
              />
            </div>
            <div style={{ marginTop: "10px" }}>
              <SxCalendar
                canEdit={true}
                docs={this.state.loadedDocs}
                sites={this.state.loadedSites}
                isBusy={this.state.isBusy}
                data={this.state}
                onUpdate={(data) => {
                  this.setState({ ...data, changed: true });
                }}
              />
            </div>
            <div style={{ marginTop: "10px" }}>
              <SxLineItems
                canEdit={true}
                isBusy={this.state.isBusy}
                data={this.state}
                onUpdate={(data) => {
                  this.setState({ ...data, changed: true });
                }}
              />
            </div>
            <div style={{ marginTop: "10px" }}>
              <SxItems
                canEdit={true}
                isBusy={this.state.isBusy}
                data={this.state}
                onUpdate={(data) => {
                  this.setState({ ...data, changed: true });
                }}
              />
            </div>
          </div>
        </div>
      );
    }
    if (this.state.lifecycle === "BOOKED") {
      return (
        <Tabs id="BOOKED__TABS">
          <Tab
            id="patientDetails"
            title="Patient Details"
            panel={
              <div>
                <PatientData
                  canEdit={true}
                  isBusy={this.state.isBusy}
                  data={this.state}
                  onUpdate={(data) => {
                    this.setState({ ...data, changed: true });
                  }}
                />
              </div>
            }
          />
          <Tab
            id="surgeonDetails"
            title="Surgery Booking Details"
            panel={
              <>
                <div>
                  <SxCalendar
                    canEdit={true}
                    docs={this.state.loadedDocs}
                    sites={this.state.loadedSites}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxBookingMetadata
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sysInv"
            title="Systemic Parameters"
            panel={
              <>
                <div>
                  <SysInv
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="lineItems"
            title="Line Items"
            panel={
              <>
                <div>
                  <SxLineItems
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxItems
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="finances"
            title="Finance"
            panel={
              <>
                <div>
                  <PanelAuths
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxPayments
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          {/* <Tab
            id="sxSteps"
            title="Notes and Adverse Events"
            panel={
              <>
                <div>
                  <SxSteps
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          /> */}
          <Tab
            id="sxVideo"
            title="Surgical Video"
            panel={
              <>
                <div>
                  <SxVideo
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sxConsumption"
            title="Consumption"
            panel={
              <>
                <div>
                  <SxConsumption
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="peopleAndEvents"
            title="Key People and Key Events"
            panel={
              <>
                <div>
                  <KeyPeople
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <KeyEvents
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="discharge"
            title="Discharge"
            panel={
              <>
                <div>
                  {/* <SxSteps
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  /> */}
                  <div style={{ marginTop: "20px" }}>
                    <Discharge
                      // setShowDischarge={(val) => {
                      //   this.setState({ ...val });
                      // }}
                      canEdit={true}
                      isBusy={this.state.isBusy}
                      data={this.state}
                      onUpdate={(data) => {
                        this.setState({ ...data, changed: true });
                      }}
                    />
                  </div>
                </div>
              </>
            }
          />
        </Tabs>
      );
    }
    if (this.state.lifecycle === "BILLED") {
      return (
        <Tabs id="BILLED__TABS">
          <Tab
            id="patientDetails"
            title="Patient Details"
            panel={
              <div>
                <PatientData
                  canEdit={true}
                  isBusy={this.state.isBusy}
                  data={this.state}
                  onUpdate={(data) => {
                    this.setState({ ...data, changed: true });
                  }}
                />
              </div>
            }
          />
          <Tab
            id="surgeonDetails"
            title="Surgery Booking Details"
            panel={
              <>
                <div>
                  <SxCalendar
                    canEdit={true}
                    docs={this.state.loadedDocs}
                    sites={this.state.loadedSites}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxBookingMetadata
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sysInv"
            title="Systemic Parameters"
            panel={
              <>
                <div>
                  <SysInv
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="lineItems"
            title="Line Items"
            panel={
              <>
                <div>
                  <SxLineItems
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxItems
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="finances"
            title="Finance"
            panel={
              <>
                <div>
                  <PanelAuths
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxPayments
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          {/* <Tab
            id="sxSteps"
            title="Notes and Adverse Events"
            panel={
              <>
                <div>
                  <SxSteps
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          /> */}
          <Tab
            id="sxVideo"
            title="Surgical Video"
            panel={
              <>
                <div>
                  <SxVideo
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sxConsumption"
            title="Consumption"
            panel={
              <>
                <div>
                  <SxConsumption
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="peopleAndEvents"
            title="Key People and Key Events"
            panel={
              <>
                <div>
                  <KeyPeople
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <KeyEvents
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="discharge"
            title="Discharge"
            panel={
              <>
                <div>
                  {/* <SxSteps
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  /> */}
                  <div style={{ marginTop: "20px" }}>
                    <Discharge
                      // setShowDischarge={(val) => {
                      //   this.setState({ ...val });
                      // }}
                      canEdit={true}
                      isBusy={this.state.isBusy}
                      data={this.state}
                      onUpdate={(data) => {
                        this.setState({ ...data, changed: true });
                      }}
                    />
                  </div>
                </div>
              </>
            }
          />
        </Tabs>
      );
    }
    if (this.state.lifecycle === "IN_BLOCK_ROOM") {
      return (
        <Tabs id="BLOCK__TABS">
          <Tab
            id="patientDetails"
            title="Patient Details"
            panel={
              <div>
                <PatientData
                  canEdit={true}
                  isBusy={this.state.isBusy}
                  data={this.state}
                  onUpdate={(data) => {
                    this.setState({ ...data, changed: true });
                  }}
                />
              </div>
            }
          />
          <Tab
            id="surgeonDetails"
            title="Surgery Booking Details"
            panel={
              <>
                <div>
                  <SxCalendar
                    canEdit={true}
                    docs={this.state.loadedDocs}
                    sites={this.state.loadedSites}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxBookingMetadata
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sysInv"
            title="Systemic Parameters"
            panel={
              <>
                <div>
                  <SysInv
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="lineItems"
            title="Line Items"
            panel={
              <>
                <div>
                  <SxLineItems
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxItems
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="finances"
            title="Finance"
            panel={
              <>
                <div>
                  <PanelAuths
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxPayments
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          {/* <Tab
            id="sxSteps"
            title="Notes and Adverse Events"
            panel={
              <>
                <div>
                  <SxSteps
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          /> */}
          <Tab
            id="sxVideo"
            title="Surgical Video"
            panel={
              <>
                <div>
                  <SxVideo
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sxConsumption"
            title="Consumption"
            panel={
              <>
                <div>
                  <SxConsumption
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="peopleAndEvents"
            title="Key People and Key Events"
            panel={
              <>
                <div>
                  <KeyPeople
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <KeyEvents
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="discharge"
            title="Discharge"
            panel={
              <>
                <div>
                  {/* <SxSteps
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  /> */}
                  <div style={{ marginTop: "20px" }}>
                    <Discharge
                      // setShowDischarge={(val) => {
                      //   this.setState({ ...val });
                      // }}
                      canEdit={true}
                      isBusy={this.state.isBusy}
                      data={this.state}
                      onUpdate={(data) => {
                        this.setState({ ...data, changed: true });
                      }}
                    />
                  </div>
                </div>
              </>
            }
          />
        </Tabs>
      );
    }
    if (this.state.lifecycle === "IN_OT") {
      return (
        <Tabs id="OT__TABS">
          <Tab
            id="patientDetails"
            title="Patient Details"
            panel={
              <div>
                <PatientData
                  canEdit={true}
                  isBusy={this.state.isBusy}
                  data={this.state}
                  onUpdate={(data) => {
                    this.setState({ ...data, changed: true });
                  }}
                />
              </div>
            }
          />
          <Tab
            id="surgeonDetails"
            title="Surgery Booking Details"
            panel={
              <>
                <div>
                  <SxCalendar
                    canEdit={true}
                    docs={this.state.loadedDocs}
                    sites={this.state.loadedSites}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxBookingMetadata
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sysInv"
            title="Systemic Parameters"
            panel={
              <>
                <div>
                  <SysInv
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="lineItems"
            title="Line Items"
            panel={
              <>
                <div>
                  <SxLineItems
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxItems
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="finances"
            title="Finance"
            panel={
              <>
                <div>
                  <PanelAuths
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxPayments
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sxVideo"
            title="Surgical Video"
            panel={
              <>
                <div>
                  <SxVideo
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sxConsumption"
            title="Consumption"
            panel={
              <>
                <div>
                  <SxConsumption
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sxSteps"
            title="Notes and Adverse Events"
            panel={
              <>
                <div>
                  <SxSteps
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          {/* <Tab
            id="sxConsumption"
            title="Consumption"
            panel={
              <>
                <div>
                  <SxConsumption
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          /> */}
          <Tab
            id="peopleAndEvents"
            title="Key People and Key Events"
            panel={
              <>
                <div>
                  <KeyPeople
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <KeyEvents
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="discharge"
            title="Discharge"
            panel={
              <>
                <div>
                  {/* <SxSteps
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  /> */}
                  <div style={{ marginTop: "20px" }}>
                    <Discharge
                      // setShowDischarge={(val) => {
                      //   this.setState({ ...val });
                      // }}
                      canEdit={true}
                      isBusy={this.state.isBusy}
                      data={this.state}
                      onUpdate={(data) => {
                        this.setState({ ...data, changed: true });
                      }}
                    />
                  </div>
                </div>
              </>
            }
          />
        </Tabs>
      );
    }
    if (this.state.lifecycle === "SX_DONE") {
      return (
        <Tabs id="SX__TABS">
          <Tab
            id="patientDetails"
            title="Patient Details"
            panel={
              <div>
                <PatientData
                  canEdit={true}
                  isBusy={this.state.isBusy}
                  data={this.state}
                  onUpdate={(data) => {
                    this.setState({ ...data, changed: true });
                  }}
                />
              </div>
            }
          />
          <Tab
            id="surgeonDetails"
            title="Surgery Booking Details"
            panel={
              <>
                <div>
                  <SxCalendar
                    canEdit={true}
                    docs={this.state.loadedDocs}
                    sites={this.state.loadedSites}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxBookingMetadata
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sysInv"
            title="Systemic Parameters"
            panel={
              <>
                <div>
                  <SysInv
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="lineItems"
            title="Line Items"
            panel={
              <>
                <div>
                  <SxLineItems
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxItems
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="finances"
            title="Finance"
            panel={
              <>
                <div>
                  <PanelAuths
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxPayments
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          {/* <Tab
            id="sxSteps"
            title="Notes and Adverse Events"
            panel={
              <>
                <div>
                  <SxSteps
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          /> */}
          <Tab
            id="sxVideo"
            title="Surgical Video"
            panel={
              <>
                <div>
                  <SxVideo
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sxConsumption"
            title="Consumption"
            panel={
              <>
                <div>
                  <SxConsumption
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="peopleAndEvents"
            title="Key People and Key Events"
            panel={
              <>
                <div>
                  <KeyPeople
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <KeyEvents
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="discharge"
            title="Discharge"
            panel={
              <>
                <div>
                  {/* <SxSteps
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  /> */}
                  <div style={{ marginTop: "20px" }}>
                    <Discharge
                      // setShowDischarge={(val) => {
                      //   this.setState({ ...val });
                      // }}
                      canEdit={true}
                      isBusy={this.state.isBusy}
                      data={this.state}
                      onUpdate={(data) => {
                        this.setState({ ...data, changed: true });

                        console.log("data", data);
                      }}
                    />
                  </div>
                </div>
              </>
            }
          />
        </Tabs>
      );
    }
    if (terminals.includes(this.state.lifecycle)) {
      return (
        <Tabs id="TERMINAL__TABS">
          <Tab
            id="patientDetails"
            title="Patient Details"
            panel={
              <div>
                <PatientData
                  canEdit={false}
                  isBusy={this.state.isBusy}
                  data={this.state}
                  onUpdate={(data) => {
                    this.setState({ ...data, changed: true });
                  }}
                />
              </div>
            }
          />
          <Tab
            id="surgeonDetails"
            title="Surgery Booking Details"
            panel={
              <>
                <div>
                  <SxCalendar
                    canEdit={false}
                    docs={this.state.loadedDocs}
                    sites={this.state.loadedSites}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxBookingMetadata
                    canEdit={false}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sysInv"
            title="Systemic Parameters"
            panel={
              <>
                <div>
                  <SysInv
                    canEdit={false}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="lineItems"
            title="Line Items"
            panel={
              <>
                <div>
                  <SxLineItems
                    canEdit={false}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxItems
                    canEdit={false}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="finances"
            title="Finance"
            panel={
              <>
                <div>
                  <PanelAuths
                    canEdit={false}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <SxPayments
                    canEdit={false}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          {/* <Tab
            id="sxSteps"
            title="Notes and Adverse Events"
            panel={
              <>
                <div>
                  <SxSteps
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          /> */}
          <Tab
            id="sxVideo"
            title="Surgical Video"
            panel={
              <>
                <div>
                  <SxVideo
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="sxConsumption"
            title="Consumption"
            panel={
              <>
                <div>
                  <SxConsumption
                    canEdit={false}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true }, () => {
                        if (this.state.itemLedgersDone) {
                          this.updateData();
                        }
                      });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="peopleAndEvents"
            title="Key People and Key Events"
            panel={
              <>
                <div>
                  <KeyPeople
                    canEdit={false}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
                <div style={{ marginTop: "20px" }}>
                  <KeyEvents
                    canEdit={false}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
          <Tab
            id="discharge"
            title="Discharge"
            panel={
              <>
                {/* <SxSteps
                  canEdit={false}
                  isBusy={this.state.isBusy}
                  data={this.state}
                  onUpdate={(data) => {
                    this.setState({ ...data, changed: true });
                  }}
                /> */}
                <div style={{ marginTop: "20px" }}>
                  <Discharge
                    // setShowDischarge={(val) => {
                    //   this.setState({ ...val });
                    // }}
                    canEdit={true}
                    isBusy={this.state.isBusy}
                    data={this.state}
                    onUpdate={(data) => {
                      this.setState({ ...data, changed: true });
                    }}
                  />
                </div>
              </>
            }
          />
        </Tabs>
      );
    }
  };
  renderInfo = () => {
    let terminals = ["SX_DONE", "DISCHARGED", "LAMA", "DEATH", "CANCELLED"];

    return (
      <ControlGroup>
        <ControlGroup>
          <Tag intent="warning" large icon="tag" style={{ marginRight: "8px" }}>
            {this.state.entityName}
          </Tag>
        </ControlGroup>
        {this.renderLifeCycleAction()}
        <Tag
          intent="primary"
          large
          style={{ marginRight: "8px", marginLeft: "8px" }}
        >
          Current: {_.startCase(_.lowerCase(this.state.lifecycle))}
        </Tag>
        {terminals.includes(this.state.lifecycle) && (
          <AnchorButton
            // disabled={this.state.showDischarge}
            outlined
            target="_blank"
            icon="prescription"
            onClick={() => {
              this.state.showDischarge
                ? window.open(
                    `https://print.newchart.care/discharge/${this.state._id}`
                  )
                : cogoToast.error(
                    "Please add the analysis in the discharge section to generate the discharge summary"
                  );
            }}

            // href={`https://print.newchart.care/discharge/${this.state._id}`}
          />
        )}
        {this.state.lifecycle !== "DRAFT" && (
          <AnchorButton
            outlined
            target="_blank"
            icon="credit-card"
            href={`https://print.newchart.care/sxPayment/${this.state._id}`}
          />
        )}
        <Button
          icon="info-sign"
          outlined
          onClick={() => {
            this.setState({ isInfoOpen: !this.state.isInfoOpen });
          }}
        />
      </ControlGroup>
    );
  };
  renderInfoBar = () => {
    let terminals = ["DISCHARGED", "LAMA", "DEATH", "CANCELLED"];
    return (
      <Card
        className="dark__bg"
        elevvation={Elevation.FOUR}
        style={{ marginBottom: "10px", padding: "5px" }}
      >
        <Collapse isOpen={this.state.isInfoOpen}>
          <ControlGroup>
            <ClickToCopy minimal={true} text={this.state._id} large={true} />
            <Tag intent="warning" minimal large>
              Updated At: {niceDateTime(this.state.updatedAt)}
            </Tag>
            <Tag intent="warning" minimal large>
              Updated By: {this.state.updatedByName}
            </Tag>
          </ControlGroup>
          {["CANCELLED"].includes(this.state.lifecycle) ? (
            <ControlGroup>
              <Tag intent="warning" minimal large>
                Cancellation Reason
              </Tag>
              <InputGroup
                style={{ width: "6em" }}
                value={this.state.cancellationReason}
                onChange={(event) => {
                  this.setState({
                    cancellationReason: event.target.value,
                    changed: true,
                  });
                }}
              ></InputGroup>
            </ControlGroup>
          ) : null}

          {terminals.includes(this.state.lifecycle) ? null : (
            <ControlGroup>
              <Tag intent="danger" icon="warning-sign" large>
                Set Lifecycle
              </Tag>
              <Tag intent="warning" icon="warning-sign">
                Please add comments if you are using this.
              </Tag>
              <Button
                outlined
                intent="danger"
                icon="warning"
                text="CANCELLED"
                onClick={() => {
                  this.setState({ lifecycle: "CANCELLED", changed: true });
                }}
              />
              <Button
                outlined
                intent="danger"
                icon="warning"
                text="LAMA"
                onClick={() => {
                  this.setState({ lifecycle: "LAMA", changed: true });
                }}
              />
              <Button
                outlined
                intent="danger"
                icon="warning"
                text="DEATH"
                onClick={() => {
                  this.setState({ lifecycle: "DEATH", changed: true });
                }}
              />
            </ControlGroup>
          )}

          <br />
          <br />
          <EntityFiles data={this.state} />
          <EntityComments data={this.state} />
        </Collapse>
      </Card>
    );
  };
  renderSaveBar = () => {
    return (
      <Card
        className="dark__bg"
        elevvation={Elevation.FOUR}
        style={{ marginBottom: "10px", padding: "5px" }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <ControlGroup>
            {this.state.patientName ? (
              <Tag
                intent="success"
                large
                icon="person"
                style={{ marginRight: "8px" }}
              >
                {_.startCase(_.lowerCase(this.state.patientName))}
              </Tag>
            ) : (
              <Tag intent="danger" large style={{ marginRight: "8px" }}>
                Patient Not Chosen
              </Tag>
            )}
            {this.state.eye ? (
              <Tag
                intent="success"
                large
                icon="eye-on"
                style={{ marginRight: "8px" }}
              >
                {this.state.eye}
              </Tag>
            ) : (
              <Tag intent="danger" large style={{ marginRight: "8px" }}>
                Eye Not Chosen
              </Tag>
            )}
            {this.state.surgeonName ? (
              <Tag
                intent="primary"
                large
                icon="diagnosis"
                style={{ marginRight: "8px" }}
              >
                {this.state.surgeonName}
              </Tag>
            ) : (
              <Tag intent="danger" large style={{ marginRight: "8px" }}>
                Surgeon Not Chosen
              </Tag>
            )}
            {this.state.anaesthesiaType ? (
              <Tag
                intent="success"
                large
                icon="syringe"
                style={{ marginRight: "8px" }}
              >
                {this.state.anaesthesiaType}
              </Tag>
            ) : (
              <Tag intent="danger" large style={{ marginRight: "8px" }}>
                Anaesthesia Not Chosen
              </Tag>
            )}
            {this.state.site ? (
              <Tag
                intent="warning"
                large
                icon="map-marker"
                style={{ marginRight: "8px" }}
              >
                {this.state.site}
              </Tag>
            ) : (
              <Tag intent="danger" large style={{ marginRight: "8px" }}>
                Site Not Chosen
              </Tag>
            )}

            {this.state.time ? (
              <Tag
                intent="warning"
                large
                icon="time"
                style={{ marginRight: "8px" }}
              >
                {niceDateTime(this.state.time)}
              </Tag>
            ) : (
              <Tag intent="danger" large style={{ marginRight: "8px" }}>
                Date Not Chosen
              </Tag>
            )}
          </ControlGroup>

          <ControlGroup>
            {this.state.changed ? (
              <Button
                icon="warning-sign"
                rightIcon="arrow-right"
                intent="warning"
                loading={this.state.isBusy}
                onClick={() => this.updateData()}
                text="Unsaved Changes! Please click to save."
              />
            ) : (
              <>{this.renderInfo()}</>
            )}
          </ControlGroup>
        </div>
      </Card>
    );
  };
  render() {
    if (this.state.isLoading) {
      return (
        <div className="padding__20">
          <NonIdealState
            icon={<Spinner />}
            title={`Loading Surgery Details...`}
            description={`Please wait while we load currently saved details`}
          />
        </div>
      );
    }
    if (this.state.isError) {
      return (
        <div className="padding__20">
          <NonIdealState
            icon="warning-sign"
            title={`Failed to load details.`}
            description={`Please check the URL you have followed, or try refreshing the page.`}
          />
        </div>
      );
    }
    return (
      <div className="padding__20">
        {this.renderSaveBar()}
        {this.renderInfoBar()}
        {this.renderBasedOnLifecycle()}
        <Dialog
          title="Are you sure you want to continue?"
          isOpen={this.state.openDailog}
          onClose={() => this.setState({ openDailog: false })}
        >
          <div className={Classes.DIALOG_FOOTER}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                flexDirection: "row",
                marginTop: "10px",
              }}
            >
              <Button
                style={{ marginRight: "5px" }}
                className={Classes.DIALOG_CLOSE_BUTTON}
                intent="primary"
                text="No"
                onClick={() => {
                  this.setState({
                    openDailog: false,
                    lifecycleToSet: this.state.lifecycle,
                  });
                }}
              />
              <Button
                className={Classes.DIALOG_FOOTER_ACTIONS}
                intent="primary"
                text="Yes"
                onClick={() => {
                  this.setState(
                    { openDailog: false, lifecycle: this.state.lifecycleToSet },
                    () => this.updateData()
                  );
                }}
              />
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default inject("authStore")(observer(withRouter(SxLanding)));
